import Header from './header';

const headerConfig = {
  name: 'siteHeader',
  class: Header,
  querySelector: {
    mobileToggle: '.mobile-toggle',
    menu: '#primary-menu',
  },
  querySelectorAll: {},
  options: {},
};

export default headerConfig;
